
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { Observable } from 'rxjs';
import { saveAs } from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { BaseListCtl } from '../common/base-list.component';
import { ServiceLocatorService } from '../common/service/service-locator.service';
import { GlobalConstants } from '../common/GlobalConstants ';

@Component({
  selector: 'app-call-logs',
  templateUrl: './call-logs.component.html',
  styleUrls: ['./call-logs.component.css']
})
export class CallLogsComponent extends BaseListCtl{

  datePickerConfig : Partial<BsDatepickerConfig>;

  constructor(public locator: ServiceLocatorService, private http: HttpClient, public route: ActivatedRoute) {
    super(locator.endpoints.CALLLOGS,locator,route);

    this.datePickerConfig = Object.assign({},
      {
        containerClass: 'theme-dark-blue',
        showWeekNumbers: true,
        
        maxDate: new Date(),
        dateInputFormat: 'DD/MM/YYYY'
      });
  }

  excelData :any;
    downloadFile(): void {
      this.download()
        .subscribe(blob => saveAs(blob, 'CallLogList.xlsx'));
    }

    download(): Observable<Blob> {
      let _self = this;
      let sid = localStorage.getItem( GlobalConstants.getKey('sessionId'));
      console.log(sid+'siddd' + this.form.searchParams);
      let url =  _self.locator.endpoints.CALLLOGS+"/exportCallLogList"+ ";jsessionid=" + sid;
      return this.http.post(url, this.form.searchParams, {
        responseType: 'blob'
      });

    }

  populateForm(form, data) {
    form.id = data.id;
    form.mobile=data.mobile;
    form.userId=data.userId;
    form.userName=data.userName;
    form.dateTime=data.dateTime;
    form.endTime = data.endTime;
    form.mobileId=data.mobileId;
    form.duration=data.dateTime;
    form.type=data.type;
    console.log('----->',data);
  }
}
